import React from 'react';
import draftToHtml from "draftjs-to-html";
import {useMemo} from "react";

export const Content = ({ value: valueProp }) => {
  const value = useMemo(() => draftToHtml(valueProp), [valueProp]);
  return (
    <div dangerouslySetInnerHTML={{ __html: value }} />
  );
};